import { render, staticRenderFns } from "./BestPractice.vue?vue&type=template&id=25ccd973&scoped=true&"
import script from "./BestPractice.vue?vue&type=script&lang=js&"
export * from "./BestPractice.vue?vue&type=script&lang=js&"
import style0 from "./BestPractice.vue?vue&type=style&index=0&id=25ccd973&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ccd973",
  null
  
)

export default component.exports